import { render, staticRenderFns } from "./AddVideoRecorderConfiguration.vue?vue&type=template&id=15d147ee&"
import script from "./AddVideoRecorderConfiguration.vue?vue&type=script&lang=js&"
export * from "./AddVideoRecorderConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports